import React from 'react';
import styled from 'styled-components';
import { Media } from '../../components';
import { FooterDesktop } from './desktop';
import { FooterMobile } from './mobile';
import { FooterTablet } from './tablet';

const FooterWrapper = styled.footer`
  background-color: black;
`;

export const Footer = () => {
  return (
    <FooterWrapper>
      <Media at="sm">
        <FooterMobile />
      </Media>
      <Media at="md">
        <FooterTablet />
      </Media>
      <Media greaterThanOrEqual="xmd">
        <FooterDesktop />
      </Media>
    </FooterWrapper>
  );
};
